import { render } from "./Administrador.vue?vue&type=template&id=03f1c77a&scoped=true"
import script from "./Administrador.vue?vue&type=script&lang=js"
export * from "./Administrador.vue?vue&type=script&lang=js"

import "./Administrador.vue?vue&type=style&index=0&id=03f1c77a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f1c77a"]])

export default __exports__